export default function(path) {
    return process.env.VUE_APP_ASSET_URL + path
}
